import React, { useState } from 'react';
import { connect } from 'react-redux';

import { toggleModal, toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { updateCardsList } from 'apps/auth/actions/cardsAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import { addExtras, setExtra, updateExtraByName } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import OccupationScreen from 'apps/auth/components/profile/aml/OccupationScreen';
import ProfileAmlLevelDocs from 'apps/auth/components/profile/aml/ProfileAmlLevelDocs';
import { ProfileAmlLevelInfo } from 'apps/auth/components/profile/aml/ProfileAmlLevelInfo';
import ProfileAmlSsnSelect from 'apps/auth/components/profile/aml/ProfileAmlSsnSelect';
import OowModal from 'apps/auth/components/send/Ach/OowModal';
import MainPlaidModal from 'apps/auth/components/send/Ach/plaid/MainPlaidModal';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { AML_LEVEL_FORM } from 'apps/auth/constants/formName';
import {
    ERROR,
    FAILED,
    INFO,
    OCCUPATION,
    OOW,
    PLAID,
    PROOF_ID,
    requestOow,
    requestPlaid,
    requestSsnOrItin,
    SSN_CONFIRM,
    SUCCESS,
} from 'apps/auth/services/achService';

export const ProfileMainACHModal = (props) => {
    const initialState = props?.extra?.plaidAccountAction ? PLAID : INFO;
    const [screen, setScreen] = useState(initialState);
    const [errorText, setErrorText] = useState('');

    const onClickContinue = () => {
        if (props.extra.canShowAmlLevelUpgrade) {
            setScreen(SSN_CONFIRM);
        } else if (props.extra.needSecretQuestionsCheck && props.extra.secretQuestionsFlow) {
            if (props.extra.secretQuestionsFlow?.errorMessage) {
                setErrorText(props.extra.secretQuestionsFlow.errorMessage);
                setScreen(ERROR);
            } else if (props.extra.secretQuestionsFlow?.questionBeans?.length > 0) {
                setScreen(OOW);
            }
        } else {
            setScreen(PROOF_ID);
        }
    };
    const onClickNotNow = () => {
        props.toggleModal(false);
    };

    const onClickSuccess = () => {
        if (props?.extra?.showAmlLevelUpScreen) {
            setScreen(INFO);
        } else if (props?.extra?.plaidAccountAction) {
            setScreen(PLAID);
        } else {
            props.toggleModal(false);
        }
    };

    const onClickContinueSsn = requestSsnOrItin(setScreen, props);
    const onClickQuestions = requestOow(setScreen, setErrorText, props);
    const onSuccessPlaid = requestPlaid(setScreen, setErrorText, props, 'profile');

    const render = (currentScreen) => {
        switch (currentScreen) {
            case INFO:
                return <ProfileAmlLevelInfo insideModalComponent onClickContinue={onClickContinue} onClickNotNow={onClickNotNow} />;
            case PROOF_ID:
                return <ProfileAmlLevelDocs />;
            case OCCUPATION:
                return <OccupationScreen />;
            case SSN_CONFIRM:
                return <ProfileAmlSsnSelect formName={AML_LEVEL_FORM} onClickContinue={onClickContinueSsn} />;
            case OOW:
                const arrayQuestions = props.extra.secretQuestionsFlow?.questionBeans;
                return (
                    <OowModal
                        maxAnswers={props.extra.secretQuestionsFlow?.maxAnswers}
                        arrayQuestions={arrayQuestions}
                        onClick={onClickNotNow}
                        skipMessage={props.pageMessages.skipQuestion}
                        onClickQuestions={onClickQuestions}
                    />
                );
            case PLAID:
                return <MainPlaidModal isShowModal={props.extra?.showAchPlaidIntro} onSuccess={onSuccessPlaid} />;
            case SUCCESS:
                return <ModalWithTimer text={props.pageMessages.successText} onClick={onClickSuccess} />;
            case FAILED:
                return (
                    <InfoPage
                        insideModalComponent={true}
                        animatedIconFail
                        headerText={props.pageMessages.errorTitle}
                        secondaryText={props.pageMessages.errorText}
                        topButtonCaption={props.pageMessages.notNow}
                        topButtonType="link"
                        topButtonLink={props.extra?.topButtonLink}
                        topButtonOnClick={onClickNotNow}
                        primaryButtonCaption={props.pageMessages.contactSupport}
                        primaryButtonOnClick={() => props.toggleChat(true)}
                    />
                );
            case ERROR:
                return (
                    <InfoPage
                        insideModalComponent={true}
                        animatedIconFail
                        mainText={errorText}
                        primaryButtonCaption={props.pageMessages.goBack}
                        primaryButtonOnClick={onClickNotNow}
                    />
                );
            default:
                return <ProfileAmlLevelInfo onClickContinue={onClickContinue} onClickNotNow={onClickNotNow} />;
        }
    };
    const isShowRightHeaderComponent = screen === SSN_CONFIRM || screen === PROOF_ID;
    return (
        <ModalComponent
            canCloseModal={false}
            isVerticalCentered={screen === FAILED || screen === ERROR || screen === INFO}
            rightHeaderComponent={
                isShowRightHeaderComponent && (
                    <Button type="button" size="tight" variant="tertiary" onClick={onClickNotNow} caption={props.pageMessages.notificationButton} />
                )
            }
        >
            {render(screen)}
        </ModalComponent>
    );
};
const mapStateToProps = ({ messages, form, extra }) => {
    return {
        fields: form[AML_LEVEL_FORM]?.fields,
        pageMessages: messages.pageMessages,
        extra: extra,
    };
};
export default connect(mapStateToProps, {
    toggleModal,
    toggleSpinner,
    updateExtraByName,
    updatePageMessages,
    toggleChat,
    setExtra,
    addExtras,
    updateMessages,
    updateCardsList,
})(ProfileMainACHModal);
